import { computed, Ref } from 'vue';
import { storeToRefs } from 'pinia';
import { v5 } from 'uuid';
import { useFeaturesStore, FEATURES_NAMESPACE_STRING, Feature } from '@/store/useFeaturesStore';

export function useFeatures() {
  const store = useFeaturesStore();
  const { list, listItem } = storeToRefs(store);

  /**
   * Returns feature value from list if list is available
   *
   * @param key
   * @param defaultValue
   * @returns {Ref<any>}
   */
  const getFeature = <T = any>(key: string, defaultValue?: T): Ref<T | undefined> => {
    const hashKey = v5(key, FEATURES_NAMESPACE_STRING);

    return computed<T | undefined>((): T | undefined => {
      if (!list.value || !Array.isArray(list.value)) {
        return defaultValue;
      }

      const flag = list.value.find((el: Feature) => el.key === hashKey);

      if (typeof flag?.value !== 'undefined') return flag.value as T;
      return defaultValue;
    });
  };

  /**
   * Returns feature value from item list if item list is available
   * @param key
   * @param defaultValue
   * @returns {Ref<any>}
   */
  const getItemFeature = (key: string, defaultValue?: any): Ref<any> => {
    const hashKey = v5(key, FEATURES_NAMESPACE_STRING);

    return computed(() => {
      if (!listItem.value || !Array.isArray(listItem.value)) {
        return defaultValue;
      }

      const flag = listItem.value.find((el: Feature) => el.key === hashKey);

      if (flag !== undefined) {
        return flag.value;
      }

      return defaultValue;
    });
  };

  return { getFeature, getItemFeature };
}
